import styled from "styled-components";

export const DefaultTextLight = styled.p`
  font-weight: 400;
`

export const DefaultTextBold = styled.p`
  font-weight: 700;
`

export const RedTextBold = styled(DefaultTextBold)`
  color: #FF2D55;
  cursor: pointer;
  
  &:hover {
    color: #FC708B;
  }
`

export const GreyTextLight = styled(DefaultTextLight)`
  color: #8692A6;
`

export const GreyTextBold = styled(DefaultTextBold)`
  color: #8692A6;
`
